module.exports = __webpack_public_path__ + "img/pr-4.b994c2f4.png";